import { useCallback, useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { CategoryItem, User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import useCategory from '../../api/hooks/useCategory';
import useToggle from '../../hooks/useToggle';
import { toIcons } from '../../consts/Paths';
import { useForm } from 'react-hook-form';
import DeleteModal from '../modals/DeleteModal';
import Loader from '../Loader';
import useReturnRules from '../../api/hooks/useReturnRules';
import { logMsgBgColors } from '../../consts/misc';
import CustomModal from '../modals/CustomModal';
import CustomInput from '../inputs/CustomInput';

const ReturnRules = (props: any) => {
    const { isMobile } = useIsMobile();

    const { isToggled } = props.resetList;
    const { write } = props.logMessage;

    const [edit, setEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({ name: '', id: 0 });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const { user, userTreated } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useReturnRules();

    const [paymentRules, setPaymentRules] = useState<CategoryItem[]>([]);

    const handelOnDeleteClick = useCallback(
        (id: number) => {
            CTAs.deleteReturnRule(id);
        },
        [CTAs.deleteReturnRule]
    );

    useEffect(() => {
        CTAs.getReturnRules();
    }, [isToggled, user, userTreated, RESPONSES.deleteReturnRulesResponse, RESPONSES.updateReturnRulesResponse]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getReturnRulesResponse?.ok) {
            setPaymentRules(
                RESULTS.getReturnRulesResult.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                }))
            );
        }
    }, [RESPONSES.getReturnRulesResponse, RESPONSES.getReturnRulesResponse, RESPONSES.updateReturnRulesResponse]);

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        setIsLoading(true);
        CTAs.updateReturnRule(data);
    };

    const openEdit = (data: any) => {
        setItem(data);
        setEdit(true);
    };

    useEffect(() => {
        reset(); // Reset the form when the modal is closed
    }, [edit, item]);

    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.updateReturnRulesResponse?.ok) {
            write('subject', 'Condition ');
            write('other_text', 'has been updated ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            setIsLoading(false);
            setEdit(false);
        } else if (RESPONSES.updateReturnRulesResponse?.ok === false) {
            write('subject', 'Condition');
            write('other_text', 'has not been addedd');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.updateReturnRulesResponse]);

    const renderPaymentRules = paymentRules.map((rule, key) => {
        return (
            <div key={key} className='user-card'>
                <p style={{ fontFamily: 'Roboto' }}>{rule.name}</p>
                <button style={{ width: 50, height: 20, paddingTop: 5, marginLeft: 10, borderRadius: 14 }} className='add-button' onClick={() => openEdit(rule)}>
                    <p style={{ fontSize: 12, margin: 0 }} className='add-buttonText'>
                        Edit
                    </p>
                </button>
                <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={() => handelOnDeleteClick(rule.id)}
                />
            </div>
        );
    });

    return (
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
            {edit && (
                <CustomModal setShow={setEdit} title='Modifica' description=''>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                        <CustomInput
                            title={'Nome'}
                            name={'name'}
                            type={'text'}
                            register={register}
                            errors={errors}
                            width={'100%'}
                            reset={reset}
                            noIcon={true}
                            defaultValue={item.name}
                            constraints={{
                                required: true,
                            }}
                        />
                        <input type='text' value={item.id} hidden {...register('id')} />
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button style={{ width: 70, marginTop: 20 }} className='add-button' type='submit'>
                                <p className='add-buttonText'>Salva</p>
                            </button>
                        )}
                    </form>
                </CustomModal>
            )}
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Return rules</p>
                    <p className='user-table-header-description'>Manage return rules</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add rule</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            style={{
                                margin: isMobile ? '0' : '',
                            }}
                        >
                            <p className='field-label'>Name</p>
                        </div>

                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'></p>
                            </div>
                        )}
                        <div
                            className='u-status'
                            style={{
                                marginLeft: isMobile ? '135px' : '',
                            }}
                        >
                            <p className='field-label'></p>
                        </div>
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    {paymentRules.length > 0 ? <div className='users-table-results scroll-y'>{renderPaymentRules}</div> : <Loader />}
                </div>
            </div>
        </div>
    );
};
export default ReturnRules;
